export function getScheduledTheme(date = new Date()) {
  const hour = date.getHours();
  return hour >= 18 || hour < 6 ? "dark" : "light";
}

export function getNextBoundary(date = new Date()) {
  const boundary = new Date(date);
  const hour = date.getHours();
  if (hour < 6) {
    boundary.setHours(6, 0, 0, 0);
  } else if (hour < 18) {
    boundary.setHours(18, 0, 0, 0);
  } else {
    boundary.setDate(boundary.getDate() + 1);
    boundary.setHours(6, 0, 0, 0);
  }
  return boundary;
}

export function resolveTheme() {
  if (typeof window === "undefined") return "dark";

  const now = new Date();
  const savedTheme = localStorage.getItem("theme");
  const overrideUntil = localStorage.getItem("themeOverrideUntil");

  if (savedTheme === null) {
    const nextBoundary = getNextBoundary(now);
    localStorage.setItem("theme", "dark");
    localStorage.setItem("themeOverrideUntil", nextBoundary.getTime().toString());
    return "dark";
  }

  if (overrideUntil && now.getTime() < parseInt(overrideUntil, 10)) {
    return savedTheme;
  }

  localStorage.removeItem("theme");
  localStorage.removeItem("themeOverrideUntil");
  return getScheduledTheme(now);
}
